/**
 * Created by anthony on 3/28/14.
 */
var putService = angular.module('putService', []);
putService.service('PutService', function(ApplicationService, RestService, $q, authServiceFactory, EditSumsModelService){
    var putEditSums = function(index)
    {
        var familyID = ApplicationService.getFamilyData().data[0].familyID;
        var edit_sums = ApplicationService.getFamilyData().edit_sums;
        var queue = [];
        for (var i = 0; i < ApplicationService.getFamilyData().data.length; i++) {
            if (typeof index !== 'undefined')
            {
                familyID = ApplicationService.getAwardData().family[index].data[0].familyID;
                edit_sums = ApplicationService.getAwardData().family[index].edit_sums;
            }
            queue.push(RestService.put("/api/family/" + familyID +  '/editsums/' + ApplicationService.getFamilyData().data[0].applicationID, edit_sums));
        }
        var promise = $q.defer();
        $q.all(queue).then(function() {
            promise.resolve(EditSumsModelService.resolveData());
        });
        return promise;
    }
    return {
        putEditSums: putEditSums,
        putApWizard: function()
        {
            return RestService.put("/api/family/" + ApplicationService.getFamilyData().data[0].familyID + '/ApWizard', ApplicationService.getFamilyData().apWizard)
        },
        putSchool: function()
        {
            return RestService.put("/api/school/" + authServiceFactory.getAuth().schoolID, authServiceFactory.getAuth());
        },
        putSchoolAddendum: function(addendum)
        {
        	return RestService.put("/api/school/" + addendum.schoolID + "/SchoolAddendum/" + addendum.recordID, addendum);
        },
        putExtraQuestion: function(question)
        {
        	return RestService.put("/api/school/" + question.schoolID + "/ExtraQuestions/" + question.recordID, question);
        },
        putAppealQuestion: function(question)
        {
            return RestService.put("/api/school/" + question.schoolID + "/AppealQuestions/" + question.recordID, question);
        },
        putTuition: function(grade)
        {
            return RestService.put("/api/school/" + grade.schoolID + "/Tuition/" + grade.recordID, grade)
        },
        putDependant: function(dep)
        {
            return RestService.put("/api/family/" + ApplicationService.getFamilyData().data[0].familyID + '/dependent/' + dep.recordID, dep)
        },
        putPolicy: function(policy)
        {
            return RestService.put("/api/school/" + policy.schoolID + '/Policy/' + policy.schoolID, policy)
        },
        putChildren: function(child)
        {
            return RestService.put("/api/family/" + ApplicationService.getFamilyData().data[0].familyID + '/children/' + child.recordID, child)
        },
        putThresholds: function()
        {
            let queue = [RestService.put("/api/family/" + ApplicationService.getFamilyData().data[0].familyID + '/familyThresholds/0', ApplicationService.getFamilyData().thresholds)];
            if (ApplicationService.getAwardData().family[1]) { // if two family situation
                // data manipulation since we store duplicate data for Thresh_Famx_Percent per-family
                // copy the thresh_famx_percent column to the other family
                let otherFamIndex = ApplicationService.getFamilyNo() * -1 + 1;
                ApplicationService.getFamilyData(otherFamIndex).thresholds["Thresh_Fam" + (ApplicationService.getFamilyNo() + 1) + "_Percent"] = ApplicationService.getFamilyData().thresholds["Thresh_Fam" + (ApplicationService.getFamilyNo() + 1) + "_Percent"];
                queue.push(RestService.put("/api/family/" + ApplicationService.getFamilyData(otherFamIndex).data[0].familyID + '/familyThresholds/0', ApplicationService.getFamilyData(otherFamIndex).thresholds));
            }
            let promise = $q.defer();
            $q.all(queue);
            return promise;
        },
        putApplicant: function()
        {
            ApplicationService.getFamilyData().edit_sums.Applicant_Total = 0;
            var restServices = [];
            for(var t=0; t < ApplicationService.getAwardData().applicants.length; t++) {
                var recordID = ApplicationService.getAwardData().applicants[t].recordID;
                var applicationID = ApplicationService.getAwardData().applicants[t].applicationID;
                //var putDataApplicant = {};
                //putDataApplicant.App_Tuition = ApplicationService.getAwardData().applicants[t].App_Tuition;
                ApplicationService.getFamilyData().edit_sums.Applicant_Total += parseInt(ApplicationService.getAwardData().applicants[t].App_Tuition);
                restServices.push(RestService.put("/api/app/" + applicationID + '/applicant/' + recordID, ApplicationService.getAwardData().applicants[t]));
            }
            ApplicationService.getAwardData().tuition = ApplicationService.getFamilyData().edit_sums.Applicant_Total;
            //putEditSums();
            return $q.all([restServices, putEditSums()]);
        }

    }
});